import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../dashboardService';
import type { TrendGranularity } from '../../../types/dashboard';

export function useDashboardKpis(role?: string) {
  return useQuery({
    queryKey: ['dashboard', 'kpis', role],
    queryFn: () => dashboardService.getKpis(role),
    refetchInterval: 30000,
    staleTime: 30000,
  });
}

export function useRevenueTrend(
  days = 7,
  enabled = true,
  range?: { dateFrom?: string; dateTo?: string },
) {
  const dateFrom = range?.dateFrom;
  const dateTo = range?.dateTo;
  return useQuery({
    queryKey: ['dashboard', 'revenue-trend', days, dateFrom ?? null, dateTo ?? null],
    queryFn: () => dashboardService.getRevenueTrend({ days, dateFrom, dateTo }),
    staleTime: 60000,
    enabled,
  });
}

export function useDepartmentStats(enabled = true) {
  return useQuery({
    queryKey: ['dashboard', 'department-stats'],
    queryFn: () => dashboardService.getDepartmentStats(),
    staleTime: 300000,
    enabled,
  });
}

export function useIncomeExpenseTrend(
  granularity: TrendGranularity = 'month',
  enabled = true,
) {
  return useQuery({
    queryKey: ['dashboard', 'income-expense-trend', granularity],
    queryFn: () => dashboardService.getIncomeExpenseTrend(granularity),
    staleTime: 60000,
    enabled,
  });
}

export function useRecentActivity(limit = 10, enabled = true) {
  return useQuery({
    queryKey: ['dashboard', 'recent-activity', limit],
    queryFn: () => dashboardService.getRecentActivity(limit),
    refetchInterval: 30000,
    staleTime: 30000,
    enabled,
  });
}
